import { render, staticRenderFns } from "./MakePayment.vue?vue&type=template&id=05d74dc4&"
import script from "./MakePayment.vue?vue&type=script&lang=js&"
export * from "./MakePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports